export { LegalList } from './LegalList';
